import { useState } from "react";
import { appSettingsService } from "@/features/settings/services/appSettings.service";
import { toastService } from "@/shared/toast";

export const useSettingsAppSettingsViewModel = () => {
  const [deleting, setDeleting] = useState(false);

  const onDeleteAccount = async () => {
    const confirmed = window.confirm(
      "Are you sure you want to delete your account? This action cannot be undone."
    );
    if (!confirmed) {
      return;
    }

    try {
      setDeleting(true);
      const response = await appSettingsService.deleteAccount();
      const isSuccess = response.success ?? true;
      if (isSuccess) {
        toastService.show(response.message || "Delete account request submitted.", "success");
      } else {
        toastService.show(response.message || "Failed to delete account.", "error");
      }
    } catch (error) {
      console.error("deleteAccount error", error);
      toastService.show("Unable to process delete account request.", "error");
    } finally {
      setDeleting(false);
    }
  };

  return {
    deleting,
    onDeleteAccount,
  };
};
